import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../ui/dialog';
import { Button } from '../../../ui/button';

interface DeleteTenantCustomCurriculumTopicsDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    topicCount: number;
    onConfirm: () => void;
}

export function DeleteTenantCustomCurriculumTopicsDialog({
    open,
    onOpenChange,
    topicCount,
    onConfirm
}: DeleteTenantCustomCurriculumTopicsDialogProps) {
    const handleConfirm = () => {
        onConfirm();
        onOpenChange(false);
    };

    const handleClose = () => {
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete topics from custom curriculum</DialogTitle>
                </DialogHeader>
                <div>
                    <p>
                        Permanently remove {topicCount} custom curriculum {topicCount === 1 ? 'topic' : 'topics'}?
                        <br />
                        This cannot be undone.
                    </p>
                </div>
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button type="button" variant="destructive" onClick={handleConfirm}>
                        Delete from curriculum
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
